const ENGAGEMENT_RING_PLATTER_BASE = "/products/engagement-ring-platter";
const HALDI_PLATTER_BASE = "/products/haldi-platter";
const WEDDING_PRESERVATION_BASE = "/products/wedding-preservation";
const RESIN_CLOCK_BASE = "/products/resin-clock";
const POOJA_THALI_BASE = "/products/pooja-thali";
const KEYCHAIN_BASE = "/products/keychain";
const RETURN_GIFTS_BASE = "/products/return-gifts";
const BABY_MEMORY_PRESERVATION_BASE = "/products/baby-memory-preservation";
const COUPLE_PHOTO_FRAME_BASE = "/products/couple-photo-frame";
const MANTRA_FRAMES_BASE = "/products/mantra-frames";
const WEDDING_INVITATION_BASE = "/products/wedding-invitation";
const CUSTOMIZED_BASE = "/products/customized";

/** Handcrafted collection items (single source of truth for home + /collection). */
export const ALL_PRODUCTS = [
  {
    icon: "💍",
    name: "Engagement Ring Platter",
    slug: "engagement-ring-platter",
    description: "A beautiful keepsake for your precious moment",
    image: `${ENGAGEMENT_RING_PLATTER_BASE}/cover.jpeg`,
    images: [
      `${ENGAGEMENT_RING_PLATTER_BASE}/cover.jpeg`,
      `${ENGAGEMENT_RING_PLATTER_BASE}/erp-2.jpeg`,
      `${ENGAGEMENT_RING_PLATTER_BASE}/erp-3.jpeg`,
      `${ENGAGEMENT_RING_PLATTER_BASE}/erp-4.jpeg`,
      `${ENGAGEMENT_RING_PLATTER_BASE}/erp-5.jpeg`,
      `${ENGAGEMENT_RING_PLATTER_BASE}/erp-6.jpeg`,
      `${ENGAGEMENT_RING_PLATTER_BASE}/erp-7.jpeg`,
    ],
    detailDescription:
      "Celebrate your yes with a handcrafted resin ring platter — a timeless keepsake for proposals, ring ceremonies, and the memories that follow. Each piece is poured and finished by hand in our studio, with soft florals, pearl accents, and a dedicated space for your ring so every detail of your moment feels intentional.",
    highlights: [
      "Made to order with your colour palette and floral style",
      "Dedicated ring slot — sized for engagement and wedding bands",
      "Gift-ready packaging for proposals and ring ceremonies",
      "Worldwide shipping with secure, cushioned packaging",
    ],
  },
  {
    icon: "🌼",
    name: "Haldi Platter",
    slug: "haldi-platter",
    description: "A vibrant keepsake for your haldi ceremony",
    image: `${HALDI_PLATTER_BASE}/cover.jpeg`,
    images: [`${HALDI_PLATTER_BASE}/cover.jpeg`, `${HALDI_PLATTER_BASE}/haldi-1.jpeg`],
    detailDescription:
      "Brighten your haldi celebration with a handcrafted resin platter — designed to hold turmeric, rituals, and little ceremonial touches in one beautiful piece. Poured and finished by hand in our studio with sunny yellows, marigold-inspired florals, and finishes that honour the joy and warmth of your pre-wedding traditions.",
    highlights: [
      "Made to order in haldi-ready yellow and floral palettes",
      "Sized for ceremony use — turmeric bowls, flowers, and ritual items",
      "Perfect for bride, groom, and family haldi setups",
      "Gift-ready packaging for wedding celebrations",
      "Worldwide shipping with secure, cushioned packaging",
    ],
  },
  {
    icon: "💐",
    name: "Wedding Flower Preservation",
    slug: "wedding-preservation",
    description: "Keep your wedding bouquet forever in crystal-clear resin",
    image: `${WEDDING_PRESERVATION_BASE}/cover.jpeg`,
    images: [
      `${WEDDING_PRESERVATION_BASE}/cover.jpeg`,
      ...Array.from({ length: 17 }, (_, i) => `${WEDDING_PRESERVATION_BASE}/wp${i + 1}.jpeg`),
    ],
    detailDescription:
      "Hold onto the most beautiful flowers from your big day — we preserve bridal bouquets, boutonnieres, and ceremony blooms in handcrafted resin keepsakes. Each piece is poured and finished by hand in our studio, capturing every petal so your wedding flowers live on as art you can display for years.",
    highlights: [
      "Bouquet, garland, and single-stem preservation available",
      "Crystal-clear resin with custom bases, frames, and shapes",
      "Ideal for brides, grooms, and anniversary gifting",
      "Guidance on sending fresh flowers after your wedding",
      "Secure packaging with worldwide delivery",
    ],
  },
  {
    icon: "💌",
    name: "Wedding Invitation",
    slug: "wedding-invitation",
    description: "Handcrafted resin invitations your guests will treasure",
    image: `${WEDDING_INVITATION_BASE}/cover.jpeg`,
    images: [
      `${WEDDING_INVITATION_BASE}/cover.jpeg`,
      `${WEDDING_INVITATION_BASE}/wi-1.jpeg`,
      `${WEDDING_INVITATION_BASE}/wi-2.jpeg`,
      `${WEDDING_INVITATION_BASE}/wi-3.jpeg`,
      `${WEDDING_INVITATION_BASE}/wi-4.jpeg`,
      `${WEDDING_INVITATION_BASE}/wi-5.jpeg`,
      `${WEDDING_INVITATION_BASE}/wi-6.jpeg`,
    ],
    detailDescription:
      "Make your wedding announcement unforgettable with resin invitation keepsakes — elegant, tactile pieces that blend your story with florals, gold accents, and crystal-clear resin. Each invitation is designed and finished by hand in our studio, so your guests receive something beautiful they will want to display long after the celebration.",
    highlights: [
      "Custom names, dates, and wedding details made to order",
      "Resin finishes with dried florals, pearls, and metallic accents",
      "Ideal for main invites, save-the-dates, and welcome gifts",
      "Coordinated sets for bride, groom, and family gifting",
      "Secure packaging with worldwide delivery",
    ],
  },
  {
    icon: "💑",
    name: "Couple Photo Frame",
    slug: "couple-photo-frame",
    description: "Your story, held in resin and love",
    image: `${COUPLE_PHOTO_FRAME_BASE}/cover.jpeg`,
    images: [
      `${COUPLE_PHOTO_FRAME_BASE}/cover.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-1.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-2.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-3.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-4.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-5.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-6.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-7.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-8.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-9.jpeg`,
      `${COUPLE_PHOTO_FRAME_BASE}/cpf-10.jpeg`,
    ],
    detailDescription:
      "Celebrate your love story with a handcrafted resin photo frame — your favourite moments preserved in crystal-clear resin with elegant florals, soft tones, and finishes made to complement your home. Each frame is made to order in our studio, so your piece feels as personal as the memories it holds.",
    highlights: [
      "Custom resin frames with your couple photos embedded or displayed",
      "Floral accents, pearls, and colour palettes tailored to your style",
      "Perfect for anniversaries, weddings, and Valentine's gifting",
      "Made to order — share your photo and preferred size with us",
      "Gift-ready packaging with secure worldwide shipping",
    ],
  },
  {
    icon: "👶",
    name: "Baby Memory Preservation",
    slug: "baby-memory-preservation",
    description: "Capture tiny hands and precious first moments forever",
    image: `${BABY_MEMORY_PRESERVATION_BASE}/cover.jpeg`,
    images: [
      `${BABY_MEMORY_PRESERVATION_BASE}/cover.jpeg`,
      ...Array.from({ length: 17 }, (_, i) => `${BABY_MEMORY_PRESERVATION_BASE}/bmp-${i + 1}.jpeg`),
    ],
    detailDescription:
      "Hold your little one's earliest days in a piece you will treasure for years. We create custom resin keepsakes featuring tiny hand and foot impressions, birth details, and delicate accents — each one poured and finished by hand to celebrate the joy of new life.",
    highlights: [
      "Hand and foot impression keepsakes in crystal-clear resin",
      "Personalised with name, date of birth, weight, and time",
      "Soft colour palettes and floral details to match your nursery",
      "Thoughtful gifting for baby showers, christenings, and first birthdays",
      "Secure packaging and worldwide delivery",
    ],
  },
  {
    icon: "🎁",
    name: "Return Gifts",
    slug: "return-gifts",
    description: "Give your guests something they'll truly cherish",
    image: `${RETURN_GIFTS_BASE}/cover.jpeg`,
    images: [
      `${RETURN_GIFTS_BASE}/cover.jpeg`,
      ...Array.from({ length: 9 }, (_, i) => `${RETURN_GIFTS_BASE}/rs-${i + 1}.jpeg`),
    ],
    detailDescription:
      "Thank your guests with return gifts they will display with pride — handcrafted resin pieces filled with florals, pearls, and thoughtful details. From weddings and engagements to baby showers and festive celebrations, each gift is made to order in our studio so your favour feels personal, elegant, and truly memorable.",
    highlights: [
      "Bulk orders for weddings, receptions, and celebrations",
      "Coordinated designs to match your event theme and colours",
      "Compact keepsakes — trays, frames, coasters, and custom pieces",
      "Name tags, dates, and monograms available on request",
      "Secure bulk packaging with worldwide delivery",
    ],
  },
  {
    icon: "🪷",
    name: "Mantra Frames",
    slug: "mantra-frames",
    description: "Sacred mantras and blessings preserved in handcrafted resin",
    image: `${MANTRA_FRAMES_BASE}/cover.jpeg`,
    images: [
      `${MANTRA_FRAMES_BASE}/cover.jpeg`,
      ...Array.from({ length: 34 }, (_, i) => `${MANTRA_FRAMES_BASE}/mf-${i + 1}.jpeg`),
    ],
    detailDescription:
      "Bring peace and positivity into your home with our Mantra Frames — handcrafted resin art featuring sacred mantras, elegant typography, and devotional finishes. Each frame is poured and finished by hand in our studio, blending spiritual meaning with the warmth of resin florals, gold accents, and soft colour palettes suited for your pooja room, entryway, or living space.",
    highlights: [
      "Custom mantra text, fonts, and layout made to order",
      "Resin finishes with florals, pearls, and gold leaf accents",
      "Ideal for home temples, gifting, and housewarming blessings",
      "Wall-ready or tabletop display options",
      "Secure packaging with worldwide delivery",
    ],
  },
  {
    icon: "🪔",
    name: "Pooja Thali",
    slug: "pooja-thali",
    description: "Sacred craft for your daily rituals",
    image: `${POOJA_THALI_BASE}/cover.jpeg`,
    images: [
      `${POOJA_THALI_BASE}/cover.jpeg`,
      ...Array.from({ length: 33 }, (_, i) => `${POOJA_THALI_BASE}/pt${i + 1}.jpeg`),
    ],
    detailDescription:
      "Elevate your daily rituals with a handcrafted Pooja Thali — resin art designed to hold diya, kumkum, rice, and offerings with grace. Each thali is poured and finished by hand in our studio, with devotional motifs, florals, and finishes that bring warmth and beauty to your home temple.",
    highlights: [
      "Custom layouts for diya, incense, and ritual items",
      "Devotional colours, florals, and gold accents made to order",
      "Ideal for home mandirs, festivals, and gifting",
      "Durable resin finish — easy to wipe clean after rituals",
      "Secure packaging with worldwide delivery",
    ],
  },
  {
    icon: "🕐",
    name: "Resin Clock",
    slug: "resin-clock",
    description: "A functional art piece that marks every hour beautifully",
    image: `${RESIN_CLOCK_BASE}/cover.jpeg`,
    images: [
      `${RESIN_CLOCK_BASE}/cover.jpeg`,
      ...Array.from({ length: 16 }, (_, i) => `${RESIN_CLOCK_BASE}/c${i + 1}.jpeg`),
    ],
    detailDescription:
      "Turn time into art with our Resin Clocks — functional wall pieces that blend real clock mechanisms with handcrafted resin, florals, and custom finishes. Each clock is poured and assembled by hand in our studio, so your home gets a one-of-a-kind statement piece that is as beautiful as it is useful.",
    highlights: [
      "Working quartz clock movement — ready to hang",
      "Custom colours, florals, and themes made to order",
      "Ideal for living rooms, bedrooms, and gifting",
      "Multiple sizes and dial styles available on request",
      "Secure packaging with worldwide delivery",
    ],
  },
  {
    icon: "🔑",
    name: "Keychain",
    slug: "keychain",
    description: "Carry a little handmade charm wherever you go",
    image: `${KEYCHAIN_BASE}/cover.jpeg`,
    images: [
      `${KEYCHAIN_BASE}/cover.jpeg`,
      ...Array.from({ length: 4 }, (_, i) => `${KEYCHAIN_BASE}/k${i + 1}.jpeg`),
    ],
    detailDescription:
      "Add a personal touch to your everyday carry with resin keychains — compact keepsakes filled with florals, glitter, initials, and custom details. Each keychain is handcrafted in our studio, making them perfect for gifting, wedding favours, and little treats for yourself.",
    highlights: [
      "Custom names, initials, and themes available",
      "Florals, pearls, glitter, and colour palettes to match your style",
      "Great for return gifts, party favours, and everyday gifting",
      "Lightweight and durable for daily use",
      "Bulk orders welcome with worldwide delivery",
    ],
  },
  {
    icon: "✨",
    name: "Customized",
    slug: "customized",
    description: "One-of-a-kind resin art made exactly to your vision",
    image: `${CUSTOMIZED_BASE}/cover.jpeg`,
    images: [
      `${CUSTOMIZED_BASE}/cover.jpeg`,
      ...Array.from({ length: 26 }, (_, i) => `${CUSTOMIZED_BASE}/c${i + 1}.jpeg`),
    ],
    detailDescription:
      "Have something special in mind? Our customized resin pieces bring your unique idea to life — from bespoke gifts and event keepsakes to home décor that reflects your story. Share your inspiration and we will design, pour, and finish every detail by hand in our studio.",
    highlights: [
      "Fully custom shapes, sizes, colours, and themes",
      "Florals, photos, text, glitter, and mixed-media options",
      "Ideal for gifts, branding, events, and personal collections",
      "We guide you from concept sketch to finished piece",
      "Secure packaging with worldwide delivery",
    ],
  },
];

/** Two rows of three — same grid as /collection */
export const HOME_COLLECTION_PREVIEW_COUNT = 6;

export function getProductBySlug(slug) {
  return ALL_PRODUCTS.find((p) => p.slug === slug);
}
